
























































































import { defineComponent, ref, useContext, useFetch } from '@nuxtjs/composition-api'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Autoplay, Pagination } from 'swiper'
import { PropType } from 'vue';
import { getCoverURL, getProductTopicBgColor } from '~/utils/solepro/products';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { addBasePath } from "~/helpers/addBasePath";

SwiperCore.use([Autoplay, Pagination])


import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import BrightcoveVideo from '../BrightcoveVideo.vue';
import PlayPause from './PlayPause.vue';
import { GALLERY_IMAGES_RESIZES } from '../../../utils/constants/product';

export default defineComponent({
    data() {
        return {
            isSSR: true,
            resizes: GALLERY_IMAGES_RESIZES
        }
    },
    mounted() {
        this.isSSR = false
    },
    setup(props) {
        const { app } = useContext()
        const { isBook, product } = props || {};
        const galleryImages = ref([]);
        const urlCover = ref(null);
        const activeIndex = ref(0)
        const isPlaying = ref([])

        const placeholderImage = addBasePath('/resources/productpage/solepro/product-placeholder.png');
        /**
         * @todo: handle fallback.
        */

        galleryImages.value = props?.product?.mediaGallery ?? [];
        galleryImages.value = galleryImages.value.filter(el => !el.disabled).sort((a, b) => a.position - b.position)
        const swiperProps = {
            loop: true,
            slidesPerView: 1,
            loopedSlides: 1,
            initialSlide: 0,
            centeredSlides: true,
            watchSlidesProgress:false,
            autoplay: {
                delay: 30000,
                enabled: true,
                disableOnInteraction: false
            },
            spaceBetween: 0,
            pagination: {
                clickable: true,
                el: ".product-incipit .swiper-pagination"
            },
            breakpoints: {
                1024: {
                    spaceBetween: 12
                }
            }
        }

        if (isBook && product) {
            urlCover.value = getCoverURL(product);
        }
        const noTopicColor = "#FFFFFF"; /** changed from #F7F7F7 to #FFFFFF because of the NEW PDP Figma  */
        const bgColor = ref(noTopicColor);
        useFetch(async () => {
            if (!isBook) {
                const categoriesStore = useCategoryStore();
                await categoriesStore.load()
                const categories = categoriesStore.rawCategories?.items[0].children
                bgColor.value = getProductTopicBgColor(categories, product, noTopicColor)
            } else {
                bgColor.value = "#F7F7F7"
            }
        })
        
        return {
            urlCover,
            galleryImages,
            swiperProps,
            placeholderImage,
            bgColor,
            activeIndex,
            isPlaying,
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
        }

    },
    methods: {
        onVideoLoaded(index) {
            /** Workaround to play the video when on first slide. The autoplay in first slide doesn't work because a bug with swiper + brightcove lib co-existence*/
            if (index != 0) return;
            const firstSlideVideo = this.$el.querySelector(`.gallery-slide [data-real-index="0"]`).closest('.gallery-slide').querySelector('video') as HTMLVideoElement;
            firstSlideVideo.pause();
            firstSlideVideo.play && firstSlideVideo.play();
        },
        afterInit(swiper) {
            if (!swiper.$el) return;
            const bulletTimer = document.createElement('span');
            bulletTimer.classList.add('bullet-timer')
            swiper.pagination.bullets.forEach(el => {
                el.classList.add('relative')
                el.classList.add('overflow-hidden')
                el.appendChild(bulletTimer.cloneNode())
            });

            setTimeout(() => {
                swiper.update();
                setTimeout(() => {
                    this.updateBulletTimer(swiper);
                }, 0)
            }, 0)


        },
        getEmbeddableURL(url) {
            if (url && url.includes('dropbox')) {
                return url.replace("dropbox.com", "dl.dropboxusercontent.com");
            } else {
                return url;
            }
        },
        updateBulletTimer(swiper) {
            if (!swiper.$el) return;
            const previousIndex = this.getPreviousRealIndex(swiper);
            const currentIndex = this.getRealIndex(swiper);
            const lastIndex = swiper.slides.length - 1;
            const isLoopToFirst = previousIndex === lastIndex && currentIndex === 0;
            const isLoopToLast = previousIndex === 0 && currentIndex === lastIndex;
            if (!swiper.pagination.bullets) return;
            if (swiper.pagination.bullets.length) {
                if (isLoopToFirst || isLoopToLast) {
                    swiper.pagination.bullets.forEach((bullet) => {
                        this.handleTimerBulletAnimation(bullet, isLoopToFirst ? false : true);
                    })
                }

                swiper.pagination.bullets.forEach((bullet, index) => {
                    if (index == parseInt(currentIndex)) {
                        this.addAnimation(bullet, swiper.params.autoplay.delay)
                    } else if (index < parseInt(currentIndex)) {
                        this.handleTimerBulletAnimation(bullet, true)
                    } else {
                        this.handleTimerBulletAnimation(bullet, false)
                    }

                })
            }
        },
        addAnimation(bullet, delay) {
            const currentBulletTimer = bullet.querySelector(".bullet-timer");
            currentBulletTimer.style.animation = `progress ${delay}ms linear forwards`;
        },
        handleTimerBulletAnimation(bullet, addClass) {
            if (addClass) {
                bullet.classList.add('prev');
            } else {
                bullet.classList.remove('prev');
            }
            bullet.offsetHeight;
            bullet.querySelector(".bullet-timer").style.animation = null;
        },
        slideChange(swiper) {
            this.updateBulletTimer(swiper);
            this.activeIndex = this.getRealIndex(swiper)

        },
        slideChangeTransitionEnd(swiper) {
            try {
                const video = swiper.slides[swiper.activeIndex].querySelector('video');
                if (video) {
                    /*const source = video.children[0];
                    source.src = source.getAttribute('data-src').replace('mp4:', '');
                    video.load();
                    video.play();*/
                    video.pause();
                    video.currentTime = 0;
                    video.play && video.play();
                }
            } catch (e) { }
        },
        getRealIndex(swiper) {
            if (!swiper.$el) return 0;
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-real-index') : 0;
        },
        getPreviousRealIndex(swiper) {
            if (!swiper.$el) return 0;
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            if (swiper.realIndex > swiper.previousIndex) { // going next
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-prev-index') : 0;
            } else { //going backwards
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-next-index') : 0;
            }
        },
        togglePlay(index) {
            let video = this.$el.querySelector(`.video-index-${index} video`) as HTMLVideoElement;
            if (!video) {
                video = this.$el.querySelector(`.video-index-${index}`) as HTMLVideoElement;
            }
            this.isPlaying[index] ? video.pause && video.pause() : video.play&&video.play();
        },
        onPlay(index) {
            const isPlaying = Object.assign([], this.isPlaying);
            isPlaying[index] = true;
            this.$set(this, 'isPlaying', isPlaying);
        },
        onPause(index) {
            const isPlaying = Object.assign([], this.isPlaying);
            isPlaying[index] = false;
            this.$set(this, 'isPlaying', isPlaying);
        }
    },
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        },
        isBook: {
            type: Boolean
        }
    },
    components: {
        SwiperSlide,
        Swiper,
        BrightcoveVideo,
        PlayPause
    },
})
